import type { OutputValueRange, ValueRangeConfigOptions } from 'flow/store/engine/types';
import { HighRangeOption, LowRangeOption } from 'flow/service/actions';

export const createNewValueRangeConfig = (
  { id, max, min }: { id: string; max?: number; min?: number },
) => ({
  id,
  minValue: min ?? null,
  maxValue: max ?? null,
  label: '',
  color: '',
});

export const getUpdatedOutputValueRange = (
  {
    valueRangeConfigOptions: { highRange, lowRange }, outputValueRange,
  }: {
    valueRangeConfigOptions: ValueRangeConfigOptions; outputValueRange: OutputValueRange[];
  },
): OutputValueRange[] => {
  if (outputValueRange.length === 0) return [];

  if (outputValueRange.length === 1) {
    return [{
      ...outputValueRange[0],
      ...(lowRange === LowRangeOption.unbounded && { minValue: null }),
      ...(highRange === HighRangeOption.unbounded && { maxValue: null }),
    }];
  }

  return [
    {
      ...outputValueRange[0],
      ...(lowRange === LowRangeOption.unbounded && { minValue: null }),
    },
    ...outputValueRange.slice(1, -1),
    {
      ...outputValueRange[outputValueRange.length - 1],
      ...(highRange === HighRangeOption.unbounded && { maxValue: null }),
    },
  ];
};

export const getUpdatedAxis = ({
  index, outputValueRange, updatedPreviousValue, updatedValue,
}) => {
  const isLowerAxisBound = index === 0;
  if (isLowerAxisBound) {
    return outputValueRange.toSpliced(index, 1, updatedValue);
  }

  const isUpperAxisBound = index === outputValueRange.length;
  if (isUpperAxisBound) {
    return outputValueRange.toSpliced(index - 1, 1, updatedPreviousValue);
  }

  return outputValueRange.toSpliced(index - 1, 2, updatedPreviousValue, updatedValue);
};

export const getRangePadding = (outputValueRange: OutputValueRange[]) => {
  const lowerBound = outputValueRange[0].minValue
    ?? outputValueRange[0].maxValue;
  const upperBound = outputValueRange[outputValueRange.length - 1].maxValue
    ?? outputValueRange[outputValueRange.length - 1].minValue;

  if (lowerBound === upperBound) {
    return 1;
  }
  return Math.ceil((upperBound - lowerBound) / (outputValueRange.length - 1));
};
